export default {
  'merchants.title': 'Merchants',
  'merchants.sectionTitle': 'Merchants',
  'merchants.menuTitle': 'Merchants',
  'merchants.table.column.merchantId': 'Merchant ID',
  'merchants.table.column.name': 'Merchant Name',
  'merchants.table.column.registrationDate': '  Registration Date',
  'merchants.table.column.mobile': 'Mobile Number',
  'merchants.table.column.email': 'Email',
};
